import React from "react";

// Admin Imports
import NFTMarketplace from "views/admin/marketplace";
import Profile from "views/admin/profile";
import ContactUs from "views/rtl/default/ContactUs";
import StudentsDashboard from "views/rtl/default/StudentsDetails";
import HoursAndInvoice from "views/rtl/default/HoursAndInvoice";
import OurServices from "views/admin/ourServices/ourServices";
import Resource from "views/rtl/default/Resource";

// Auth Imports
import SignIn from "views/auth/SignIn";

// Icon Imports
import {
  MdHome,
  MdBarChart,
  MdPerson,
  MdLock,
  MdContacts,
  MdAddTask,
  MdReport,
  MdModelTraining
} from "react-icons/md";

const routes = [
   {
    name: "Dashboard",
    layout: "/admin",
    path: "default",
    icon: <MdHome className="h-6 w-6" />,
    component: <NFTMarketplace />,
  },
  /*{
    name: "NFT Marketplace",
    layout: "/admin",
    path: "nft-marketplace",
    icon: <MdHome className="h-6 w-6" />,
    component: <NFTMarketplace />,
  },
   {
    name: "NFT Marketplace",
    layout: "/admin",
    path: " ",
    icon: <MdOutlineShoppingCart className="h-6 w-6" />,
    component: <NFTMarketplace />,
    secondary: true,
  }, */
  {
    name: "Our Services",
    layout: "/admin",
    icon: <MdBarChart className="h-6 w-6" />,
    path: "services",
    component: <OurServices />,
  },
  {
    name: "About",
    layout: "/admin",
    path: "profile",
    icon: <MdPerson className="h-6 w-6" />,
    component: <Profile />,
  },
  {
    name: "Sign In",
    layout: "/auth",
    path: "sign-in",
    icon: <MdLock className="h-6 w-6" />,
    component: <SignIn />,
  },
  {
    name: "Add Student",
    layout: "/rtl",
    path: "students-details",
    icon: <MdAddTask className="h-6 w-6" />,
    component: <StudentsDashboard />,
  },
  {
    name: "Hours and Invoice",
    layout: "/rtl",
    path: "hours-invoice",
    icon: <MdReport className="h-6 w-6" />,
    component: <HoursAndInvoice />,
  },
  {
    name: " Resources",
    layout: "/admin",
    path: "resources",
    icon: <MdModelTraining className="h-6 w-6" />,
    component: <Resource />,
  },
  {
    name: "Contact Us",
    layout: "/admin",
    path: "contact-us",
    icon: <MdContacts className="h-6 w-6" />,
    component: <ContactUs />,
  },
];
export default routes;
